<template>
    <span class="text-danger" v-if="permiteCancelarEnvioParaAnalise">
        <i
            class="fa fa-ban fa-lg icon-button mr-1"
            title="Cancelar Envio para análise"
            @click.stop="confirmarCancelarEnvioParaAnalise()"
        ></i>
    </span>
</template>

<script>
import { comprometimentoStatus } from './ComprometimentoStatus'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        comprometimento: {
            type: Object,
            default: () => ({})
        },

        anexo: {
            type: Object,
            default: () => ({})
        },

        dataServico: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarCancelarEnvioParaAnalise() {
            this.$swal({
                title: 'Cancelamento do envio para análise',
                html: `Confirma o cancelamento do envio do serviço <b>${this.comprometimento.idComprometimento}</b> para análise?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.cancelarEnvioParaAnalise()
                }
            })
        },

        cancelarEnvioParaAnalise() {
            this.$store.dispatch('addRequest')
            this.dataServico
                .cancelarEnvioComprometimentoParaAnalise(
                    this.$route.params.codContrato,
                    this.comprometimento.idComprometimento
                )
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Serviço enviado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obter-atualizacao')
                        } else {
                            this.$toast.error(
                                'Erro ao enviar serviço para análise',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        permiteCancelarEnvioParaAnalise() {
            return (
                this.comprometimento.status ==
                    comprometimentoStatus.EM_ANALISE &&
                this.$temAcessoView('FORN-CONTRATOS-00')
            )
        }
    }
}
</script>
